module.exports = __webpack_public_path__ + "img/PDAC1_Neutrophils.ab672c0f.png";